import type { User } from "./auth-context";

/** Avatar URL from OAuth / Supabase user_metadata (flattened to strings in our User type). */
export function getOAuthAvatarUrl(user: User | null | undefined): string | null {
  if (!user?.user_metadata) return null;
  const m = user.user_metadata;
  const a = m.avatar_url?.trim();
  if (a) return a;
  const p = m.picture?.trim();
  if (p) return p;
  return null;
}

/**
 * Return a lighter avatar URL for nav/profile chips.
 * - Supabase Storage: add built-in transform params.
 * - Other providers: return original URL untouched.
 */
export function getOptimizedAvatarUrl(
  rawUrl: string | null | undefined,
  size: 'sm' | 'md' = 'sm',
): string | null {
  if (!rawUrl || typeof rawUrl !== 'string') return null;
  const url = rawUrl.trim();
  if (!url) return null;

  // Supabase storage public object URLs support query transforms.
  if (url.includes('/storage/v1/object/public/')) {
    try {
      const u = new URL(url);
      const px = size === 'md' ? 96 : 64;
      u.searchParams.set('width', String(px));
      u.searchParams.set('height', String(px));
      u.searchParams.set('resize', 'cover');
      u.searchParams.set('quality', '70');
      return u.toString();
    } catch {
      return url;
    }
  }

  return url;
}
